// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"349":"281b87b8","727":"3c1069e8","843":"3ce09d87","940":"a2ebb165"}[chunkId] + ".js";
};